import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]

import { IonIcon } from "@ionic/vue";

import { ImageLinkProps } from "@/types/props";
import { isApp } from "@/functions/enviroment";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageProduct',
  props: {
    contained: { type: Boolean },
    imageLink: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["image-container center-x", { 'px-5 py-3': __props.contained, 'app-image': _unref(isApp)(), 'placeholder-icon': !__props.imageLink }])
  }, [
    (__props.imageLink)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "product-image",
          alt: "",
          src: (__props.imageLink.startsWith('/')) ? `https://app.octopusorder.com${__props.imageLink}` : __props.imageLink
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createBlock(_unref(IonIcon), {
          key: 1,
          src: "assets/icon/item.svg",
          class: "purple-purple-color",
          style: {"height":"100%","width":"100%"}
        }))
  ], 2))
}
}

})